import { render, staticRenderFns } from "./holidayListDetail.vue?vue&type=template&id=0fac9108&"
import script from "./holidayListDetail.vue?vue&type=script&lang=js&"
export * from "./holidayListDetail.vue?vue&type=script&lang=js&"
import style0 from "./holidayListDetail.vue?vue&type=style&index=0&id=0fac9108&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports